import RemoteStore from "../lib/util/remote-store";

class MigrationService {
	cache = {};

	async getIndex(sub) {
		if (!this.cache[sub]) {
			this.cache[sub] = RemoteStore.list(
				`collection=migrations/sub=us-east-2:${sub}`,
				'public',
				500
			);
		}
		return this.cache[sub];
	}
}

export default new MigrationService();
